import dayjs from 'dayjs';

function isLate(isLate: string): boolean {
  if (!isLate) {
    return false;
  }

  const isLateValue = dayjs(isLate).isAfter(dayjs(new Date()), 'day');
  return isLateValue;
}

export default isLate;
